import { appUrl } from "@src/cloud-connect/feature-toggles/feature-toggles";
import TokensExpiredError from "../errors/tokens-expired-error";
import { buildAuthenticationBody } from "../util/build-authentication-body";
import { buildAuthenticationHeaders } from "../util/build-authentication-headers";

interface FetchNodeTimeseriesDataDto {
  groupId: string;
  nodeId: string;
}

// Timeseries Call - five
export const fetchNodeTimeseriesDataWithNodeId = (
  groupId: string,
  nodeId: string,
) => {
  /* const testNameSpace = "11657baf-3052-481c-a7ee-d0ec7c12e627"; */
  // const ts_uuid = "043ed156-617b-5e31-8da1-74e815a0d646";

  const result = fetch(`${appUrl()}/api/get-time-series-data-with-node-id`, {
    method: "POST",
    headers: buildAuthenticationHeaders(),
    body: JSON.stringify({
      ...buildAuthenticationBody(),
      group_id: groupId,
      node_id: nodeId,
    }),
  })
    .then(async (res) => {
      if (res.ok) {
        return res.json();
      } else if (res.status === 404) {
        const json = await res.json();

        if (json.errorId === "404-6-2") {
          return json;
        } else {
          return null;
        }
      } else if (res.status === 422) {
        const json = await res.json();

        if (json.errorId === "422-6-2") {
          return json;
        } else {
          return null;
        }
      } else {
        const json = await res.json();
        if (json.message === "Refresh Token is expired") {
          throw new TokensExpiredError("All Tokens Expired");
        } else {
          throw new Error("Server Responded with 500");
        }
      }
    })
    .then((data) => {
      if (data !== undefined) {
        return data;
      }
    })
    .catch((err) => {
      if (err instanceof TokensExpiredError) {
        console.log("error: ", err);
      } else if (err instanceof DOMException) {
        return;
      } else {
        console.log("generic error", err);
      }
    });

  return result;
};
